<template>
  <div class="app-tooltip" :class="{ 'app-tooltip--right': align === 'right' }" :data-tooltip="text || ''">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppTooltip',
  props: {
    text: { type: String, default: '' },
    align: { type: String, default: 'left' }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppTooltip.vue